import { UAParser } from 'ua-parser-js';

export const createUserAgentParser = () => {
  const userAgent = navigator && navigator.userAgent ? navigator.userAgent : '';
  const userAgentParser = new UAParser(userAgent);
  return userAgentParser;
};

export default createUserAgentParser;
